import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { WingFoilCampaignPage } from './pages/WingFoilCampaignPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
import { CorporateTeamBuildingPage } from './pages/CorporateTeamBuildingPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="stkmm0v5ce17">
      <ScrollToTop data-id="element-1" data-mp="stc7s3fgqynd" />
      <Routes data-id="element-2" data-mp="sssskuh76od1">
        <Route path="/" element={<BeachClubPage data-id="element-4" data-mp="3688rpx40wyp" />} data-id="element-3" data-mp="swgmhuqk1csa" />
        <Route path="/sup" element={<SUPPage data-id="element-6" data-mp="34nd1wz277z9" />} data-id="element-5" data-mp="35ghgrajple8" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" data-mp="3udkmfuysas9v" />} data-id="element-7" data-mp="3uct43lu76r1j" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" data-mp="3uf5gljh6s977" />} data-id="element-9" data-mp="3uc9jtyh2rqkc" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" data-mp="d3cwvvain2i5" />} data-id="element-11" data-mp="d57ep0qhqei0" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" data-mp="85ully910b6z" />} data-id="element-13" data-mp="d2l7x3bfc30u" />
        <Route path="/wingfoil-campaign" element={<WingFoilCampaignPage data-id="element-16" data-mp="83i6rtykegy5" />} data-id="element-15" data-mp="86mgf6usu4w7" />
        <Route path="/events" element={<EventsPage data-id="element-18" data-mp="3gm65ruscn35z" />} data-id="element-17" data-mp="3gkv1zuywlvev" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-20" data-mp="3bmthr6pqrq1t" />} data-id="element-19" data-mp="3gja7u6gi4ehj" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-22" data-mp="3bkgss9lkgff9" />} data-id="element-21" data-mp="3bnuurgqbimm6" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-24" data-mp="3qcqyj1lcddgz" />} data-id="element-23" data-mp="3qbpon0g2ax0u" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-26" data-mp="3lk7kk3iqsgbn" />} data-id="element-25" data-mp="3lkheg26wr7mm" />
        <Route path="/admin" element={<AdminDashboard data-id="element-28" data-mp="3limsckjwh9gy" />} data-id="element-27" data-mp="3liwkoesf3spt" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-30" data-mp="2xsk2mb3gkfli" />} data-id="element-29" data-mp="2xud9nrhzh1u1" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-32" data-mp="2stpmxi0sf75m" />} data-id="element-31" data-mp="2swlgyv9ilbos" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-34" data-mp="18byasb3eml36" />} data-id="element-33" data-mp="18d9ds8p0zot8" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-36" data-mp="1d6kowm0verqy" />} data-id="element-35" data-mp="1d5j9648wth2w" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-38" data-mp="ygwkhbxe7cz0" />} data-id="element-37" data-mp="yfv6ozozscdl" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-40" data-mp="13e56jnlnw15j" />} data-id="element-39" data-mp="ydija70gt9t5" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-42" data-mp="1r4971m3jzksb" />} data-id="element-41" data-mp="13f7ubmnotnh8" />
        <Route path="/team-building" element={<CorporateTeamBuildingPage data-id="element-44" data-mp="1w3c2cetqecn3" />} data-id="element-43" data-mp="1r5ame2rlqtfu" />
      </Routes>
      <ConditionalFloatingButton data-id="element-45" data-mp="1w2u091ke1479" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on Water Tribe Fest page, Thank You page, or Tranzila Success page
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water' || location.pathname === '/team-building' || location.pathname === '/wingfoil-campaign') {
    return null;
  }
  if (location.pathname === '/events') {
    return <FloatingJoinButton label="השאירו פרטים" data-id="element-46" data-mp="ca2ghl2sk3jz" />;
  }
  return <FloatingJoinButton data-id="element-47" data-mp="19w9pd764oi25" />;
}